import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function CategoryDetails({ children }) {
  useInjectSaga({ key: 'categoryDetails', saga });
  useInjectReducer({ key: 'categoryDetails', reducer });

  return React.Children.only(children);
}

CategoryDetails.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withCategoryDetails } from './withCategoryDetails';
export default compose(withConnect, memo)(CategoryDetails);
